export default __webpack_public_path__ + "static/media/bg-wa.bded4f44.png";